import { ActivityV2 } from 'models/activityV2'
import styled from 'styled-components'

export type CellEventFormatterProps = {
  event: ActivityV2
}

export const contentTypeMap: Record<string, any> = {
  contact: 'Contact',
  contactcompany: 'Company',
  contactnote: 'Contact Note',
  companynote: 'Company Note',
  doornote: 'Location Note',
  deal: 'Deal',
  doorproxy: 'Location',
  product: 'Product',
  variant: 'Product Variant',
  savedview: 'Saved Filter',
  campaign: 'Campaign',
  reminder: 'Reminder',
  samplerequest: 'Sample Request',
  document: 'Document',
}

export const convertSnakeCaseToSentenceCase = (str: string) => {
  const formattedStr = str.split('_').join(' ')
  return formattedStr
}

const simpleDateFormatter = (date: string) => {
  if (!date) return ''
  return new Date(date).toLocaleDateString()
}

const simpleBooleanToYesNo = (value: boolean) => (value ? 'Yes' : 'No')

/**
 * Safely convert any value to a string for rendering.
 * Handles objects with {name, email} (e.g., email contacts) and arrays.
 */
const safeValueToString = (value: unknown): string => {
  if (value === null || value === undefined) return ''
  if (typeof value === 'string') return value
  if (typeof value === 'number' || typeof value === 'boolean')
    return String(value)

  // Handle arrays (e.g., email contact lists)
  if (Array.isArray(value)) {
    return value
      .map((item) => {
        if (typeof item === 'object' && item !== null) {
          // Handle email contact objects {name, email}
          if ('name' in item || 'email' in item) {
            return item.name || item.email || ''
          }
          return JSON.stringify(item)
        }
        return String(item)
      })
      .filter(Boolean)
      .join(', ')
  }

  // Handle single objects (e.g., {name, email})
  if (typeof value === 'object') {
    const obj = value as Record<string, unknown>
    if ('name' in obj || 'email' in obj) {
      return String(obj.name || obj.email || '')
    }
    return JSON.stringify(value)
  }

  return String(value)
}

export const getFieldFormatter = (field: string, contentType: string) => {
  const mapping: Record<string, Record<string, (value: any) => string>> = {
    contactcompany: {
      created: simpleDateFormatter,
      modified: simpleDateFormatter,
    },
    contact: {
      created: simpleDateFormatter,
      modified: simpleDateFormatter,
      consent_to_contact: simpleBooleanToYesNo,
    },
    deal: {
      created: simpleDateFormatter,
      modified: simpleDateFormatter,
      close_date_override: simpleDateFormatter,
      last_datetime_stage_changed: simpleDateFormatter,
      datetime_closed: simpleDateFormatter,
    },
    product: {
      estimated_sales_potential: (value: string) => `${value}`,
    },
  }
  // Use safe default formatter to prevent React error #31 (objects as children)
  return mapping[contentType]?.[field] || safeValueToString
}

export const GreenBold = styled.b`
  color: #087443;
`

export const PillContainer = styled.span`
  display: inline-flex;
  margin: 0 2px;
`
